const React = require('react')
const PropTypes = require('prop-types')
const { useState } = React
const { Popover } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { useHistory } = require('react-router-dom')

require('@styles/components/popover.css')

const TransactionsPopover = props => {
    const { id, transaction, activePreview, setActivePreview } = props
    const { network } = useNetworkConfig()
    const history = useHistory()

    const [data, setData] = useState([
        {
            label: 'Status:',
            value: (
                <div className={`preview-status ${transaction.status ? 'success' : 'fail'}`}>
                    <i className={`fas ${transaction.status ? 'fa-check' : 'fa-times'}`} />
                    {transaction.status ? 'Success' : 'Fail'}
                </div>
            )
        },
        {
            label: 'Transaction Fee:',
            value: `${((transaction.gasPrice * transaction.gasUsed) / 10 ** 18).toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 9
            })} ${network.data.token}`
        },
        {
            label: 'Gas Info:',
            value: `${transaction.gasUsed.toLocaleString()} gas used from ${transaction.gas.toLocaleString()} limit`
        },
        {
            label: 'Nonce:',
            value: (
                <>
                    {transaction.nonce}&nbsp;
                    <span style={{ color: 'var(--grey-color)' }}>in the position {transaction.transactionIndex}</span>
                </>
            )
        }
    ])

    return (
        <>
            <button
                className={`${network.name}-preview-button ${network.name}-icon-wrapper`}
                id={id}
                onClick={() => setActivePreview(activePreview === id ? null : id)}
            >
                <i className='fas fa-eye' />
            </button>
            <Popover
                placement='right'
                isOpen={activePreview === id}
                target={id}
                toggle={() => setActivePreview(null)}
                className='preview-popover'
            >
                <div className='preview-content'>
                    <div className='preview-title'>Additional Info</div>
                    {data.map(item => (
                        <div className='preview-row'>
                            <span className='preview-label'>{item.label}</span>
                            <span className='preview-value'>{item.value}</span>
                        </div>
                    ))}
                    <div className='preview-see-more'>
                        <a
                            href={`/${network.name}/tx/${transaction.hash}`}
                            onClick={e => {
                                e.preventDefault()
                                history.push(`/${network.name}/tx/${transaction.hash}`)
                            }}
                        >
                            See more details
                            <i className='fas fa-external-link-alt' />
                        </a>
                    </div>
                </div>
            </Popover>
        </>
    )
}

TransactionsPopover.propTypes = {
    id: PropTypes.string.isRequired,
    transaction: PropTypes.shape({
        hash: PropTypes.string.isRequired,
        status: PropTypes.bool.isRequired,
        gasPrice: PropTypes.number.isRequired,
        gasUsed: PropTypes.number.isRequired,
        nonce: PropTypes.number.isRequired
    }).isRequired,
    activePreview: PropTypes.string,
    setActivePreview: PropTypes.func.isRequired
}

module.exports = { TransactionsPopover }
